import { render, staticRenderFns } from "./BtImportValidations.vue?vue&type=template&id=13bf7c66&scoped=true&"
import script from "./BtImportValidations.vue?vue&type=script&lang=js&"
export * from "./BtImportValidations.vue?vue&type=script&lang=js&"
import style0 from "./BtImportValidations.vue?vue&type=style&index=0&id=13bf7c66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bf7c66",
  null
  
)

export default component.exports